// Thin API client. All calls attach local-only key headers. Errors are returned
// as { ok:false, code, message } with a layman message safe to show users.

import { keyHeaders } from './keys.js'

// Talk to the Express backend directly when running on the Vite dev port, so we
// never depend on the dev proxy being active. In production the app is served by
// Express itself (same origin), so use relative paths.
const API_BASE = import.meta.env.DEV
  ? `${location.protocol}//${location.hostname}:8787`
  : ''

async function call(path, body, method = 'POST') {
  const dev = { path, body }
  try {
    const res = await fetch(API_BASE + path, {
      method,
      headers: { 'content-type': 'application/json', ...keyHeaders() },
      body: method === 'GET' ? undefined : JSON.stringify(body || {})
    })
    const data = await res.json().catch(() => ({ ok: false, code: 'bad_response', message: 'Unexpected response from server.' }))
    if (!data.ok) {
      // Developer-only diagnostics (console), never surfaced to users.
      console.error('[autoworld:api]', { ...dev, status: res.status, code: data.code, message: data.message })
    }
    return data
  } catch (e) {
    console.error('[autoworld:api] network', { ...dev, error: e.message })
    return { ok: false, code: 'network_error', message: 'Could not reach the studio server. Is it running?' }
  }
}

export const api = {
  getState: () => call('/api/state', null, 'GET'),
  getAssets: () => call('/api/assets', null, 'GET'),
  tick: (state, deltaSeconds, force = false) => call('/api/agents/tick', { state, deltaSeconds, force }),
  chat: (state, text) => call('/api/chat', { state, text }),
  reset: (mode, prompt, title, domain) => call('/api/sim/reset', { mode, prompt, title, domain }),
  llmPing: () => call('/api/llm/ping', {}),
  meshy: (tool, payload) => call(`/api/tools/meshy/${tool}`, payload),
  deployGithub: () => call('/api/deploy/github', {}),
  deployNetlify: () => call('/api/deploy/netlify', {})
}
